import type { LinkInfo } from '@/@types/post'
import ClickWrapper from '@/components/ClickWrapper'
import useUniversalNavigate from '@/utils/hooks/useUniversalNavigate'
import { css } from '@emotion/react'
import type { HTMLAttributes } from 'react'

export interface LinkCardProps extends HTMLAttributes<HTMLDivElement> {
	data: LinkInfo | undefined
}

export default function LinkCard({ data, ...props }: LinkCardProps) {
	const navigate = useUniversalNavigate()
	if (!data) {
		return null
	}
	const { audio, pictureUrl, title, brandLogoImage, linkUrl } = data
	return (
		<ClickWrapper
			whileTap={{
				scale: 0.98,
			}}
			onClick={(e) => {
				e.stopPropagation()
				navigate(linkUrl, e)
			}}
		>
			<div
				{...props}
				css={css`
					height: 82px;
					border-radius: 4px;
					overflow: hidden;
					background: var(--bg-on-body-2, #f0f3f5);
					display: grid;
					align-items: center;
					grid-template-columns: 58px 1fr;
					grid-gap: 16px;
					padding: 12px;
				`}
			>
				<div>
					<img
						loading="lazy"
						referrerPolicy="no-referrer"
						src={pictureUrl}
						css={css`
							aspect-ratio: 1 / 1;
							width: 100%;
							object-fit: cover;
							display: block;
						`}
					/>
				</div>
				<div css={css``}>
					<header
						css={css`
							font-size: 16px;
							line-height: 19px;
							height: 38px;
							overflow: hidden;
							text-overflow: ellipsis;
							display: -webkit-box;
							-webkit-box-orient: vertical;
							-webkit-line-clamp: 2;
						`}
					>
						{title}
					</header>
					<footer
						css={css`
							color: var(--tint-secondary);
							font-size: 14px;
							line-height: 20px;
							display: flex;
							justify-content: space-between;
						`}
					>
						<div>
							{/* author */}
							{audio?.author}
						</div>
						<div>{/* brand? */}</div>
					</footer>
				</div>
			</div>
		</ClickWrapper>
	)
}
